// extracted by mini-css-extract-plugin
export default {"tabs":"h_v","tab-list":"h_w","tab":"h_x","active":"h_y"};